import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@commenda/kakashi';

interface ApproveCertificateConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isRejectedCertificate: boolean;
  isLoading: boolean;
}

const ApproveCertificateConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  isRejectedCertificate,
  isLoading,
}: ApproveCertificateConfirmationModalProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent
        className="max-w-[442px] p-0"
        hideCloseIcon
        preventCloseOnOutsideClick
      >
        <DialogHeader className="border-b-0 pb-2">
          <DialogTitle>
            {isRejectedCertificate
              ? 'Approve this rejected certificate?'
              : 'Approve this certificate?'}
          </DialogTitle>
        </DialogHeader>

        <div className="px-3xl">
          <p className="txt-small-regular text-text-tertiary">
            {isRejectedCertificate
              ? 'This certificate was previously rejected. This action will override the previous rejection and will be logged for audit purposes.'
              : 'This action will approve the certificate and notify the customer. The exemption will become active immediately.'}
          </p>
        </div>

        <DialogFooter className="border-t-0">
          <div className="flex gap-md items-center justify-end">
            <Button variant="secondary" size="md" onClick={onClose}>
              Cancel
            </Button>
            <Button
              variant="primary"
              size="md"
              onClick={onConfirm}
              disabled={isLoading}
            >
              Approve certificate
            </Button>
          </div>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ApproveCertificateConfirmationModal;
